import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const StaffProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Check if user is staff
  const isStaff = currentUser?.userTypes?.staff === true;

  if (!isStaff) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default StaffProtectedRoute;
